import { WebPortalService } from "../resource";
import swal from "sweetalert2";
import i18n from "./i18n";
import { get } from "vue-cookie";

const ReportModule = {
  namespaced: true,
  state: {
    cdr: [],
    dashboard: null,
    summary: null
  },
  mutations: {
    SET_CDR(state, data) {
      state.cdr = data;
    },
    SET_DASHBOARD(state, data) {
      state.dashboard = data;
    },
    SET_SUMMARY(state, data) {
      state.summary = data;
    }
  },
  actions: {
    clearReportCDR({ commit, state }, params) {
      commit("SET_CDR", []);
    },
    clearReportSummary({ commit, state }, params) {
      commit("SET_SUMMARY", null);
    },
    clearReportDashboard({ commit, state }, params) {
      commit("SET_DASHBOARD", null);
    },

    async listReportCDR({ commit, state }, params) {
      try {
        swal.fire({
          title: i18n.t(`processing`),
          type: "info",
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: i18n.t(`close`),
        });

        const resp = await WebPortalService.ReportCDRGet(params);
        let data = resp.data;
        console.log("data", data);
        console.log("datum", data.Data[0]);
        console.log("data_cdr", data.Data[0].records);
        console.log("data_summary", data.Data[0].summaries_by_date);
        console.log("data_dashboard", data.Data[0].summaries);

        commit("SET_CDR", data.Data[0].records);
        commit("SET_SUMMARY", data.Data[0].summaries_by_date);
        commit("SET_DASHBOARD", data.Data[0].summaries);
        swal.close()
      } catch (err) {
        console.log("err", err);
        swal.close()
      }
    }
  },

  getters: {
    getReportCDR(state) {
      return state.cdr;
    },
    getReportSummary(state) {
      return state.summary;
    },
    getReportDashboard(state) {
      return state.dashboard;
    }
  }
};

export default ReportModule;
